import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { useHistory, useLocation } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import DateRangeFilter from '../../pages/Reports/Filters/DateRangeFilter/DateRangeFilter'
import Loading from '../../templates/UI/Loading/Loading'
import Affiliate from '../../templates/Affiliate/Affiliate'
import callAPI from '../../helpers/callAPI'

import AffiliateNavbar from '../../pages/Affiliate/Templates/AffiliateNavbar/AffiliateNavbar'
import useDateRangeFilter from '../../hooks/useDateRangeFilter'
import ReportTable from '../../templates/ReportTable/ReportTable'
import Campaign from '../../templates/Campaign/Campaign'
import CampaignNavbar from '../../pages/Campaign/CampaignNavBar/CampaignNavBar'

const CampaignViews = ({ affiliateId, campaignId, showSystemMessage }) => {
    const [dataLoaded, setDataLoaded] = useState(false)
    const history = useHistory()
    const location = useLocation()
    const [report, setReport] = useState([])
    const [affiliate, setAffiliate] = useState({})
    const [campaign, setCampaign] = useState({})

    const { initStartDate, initEndDate, selectedStartDate, selectedEndDate, quickDate, handleChangeStart, handleChangeEnd, handleQuickDate } = useDateRangeFilter()

    const spinner = <FontAwesomeIcon icon="spinner" spin />

    if (affiliate.id){
        document.title = `${affiliate.name}: Campaign Views`
    } else if (campaign.id){
        document.title = `${campaign.name}: Campaign Views`
    } else {
        document.title = 'Campaign Views'
    }

    useEffect(() => {
        getReport()
    }, [location])

    const refreshReport = (e) => {
        // We want the URL in the url bar to update when refreshing via the button, so all it does is navigate you to a new page with tnpmhe SELECTED options
        e.preventDefault()
        let url = affiliateId ? `/affiliate/${affiliateId}/campaignViews?startDate=${selectedStartDate}&endDate=${selectedEndDate}` : `/campaign/${campaignId}/campaignViews?startDate=${selectedStartDate}&endDate=${selectedEndDate}`

        history.push(url)
    }

    const getReport = async () => {
        setDataLoaded(false)

        let url = affiliateId ? `affiliate/${affiliateId}/campaignViews?startDate=${initStartDate}&endDate=${initEndDate}` : `campaign/${campaignId}/campaignViews?startDate=${initStartDate}&endDate=${initEndDate}`

        callAPI(url, 'GET')
            .then((result) => {
                if (result['success'] === true) {
                    affiliateId ? setAffiliate(result.affiliate) : setCampaign(result.campaign)
                    setReport(result.view_list)
                    setDataLoaded(true)
                } else if (result['success'] === false) {
                    showSystemMessage('error', result.errors.message)
                    setDataLoaded(true)
                }
            })
            .catch((error) => {
                console.log(`Error while fetching affiliate login history: ${error}`)
                showSystemMessage('error', 'An error occurred while fetching affiliate login history')
            })
    }

    const getReportOutput = () => {
        let columns = [
            {
                Header: 'ID',
                accessor: 'item_id',
                Cell: ({ cell: { value } }) => {
                    return <>{value}</>
                },
            },
            {
                Header: affiliateId ? 'Campaign' : 'Affiliate',
                accessor: 'item_name',
                Cell: (tableData) => {
                    return affiliateId ? <Campaign oid={tableData.data[tableData.row.index].item_id} name={tableData.data[tableData.row.index].item_name} status={tableData.data[tableData.row.index].item_status} /> : <Affiliate aid={tableData.data[tableData.row.index].item_id} name={tableData.data[tableData.row.index].name} status={tableData.data[tableData.row.index].item_status} priority={tableData.data[tableData.row.index].aff_priority} />
                },
            },
            {
                Header: <div style={{ textAlign: 'center' }}>Times Viewed</div>,
                accessor: 'view_count',
                className: 'text-center',
                Cell: ({ cell: { value } }) => {
                    return <>{value}</>
                },
            },
            {
                Header: 'Last View',
                accessor: 'view_date',
                Cell: ({ cell: { value } }) => {
                    return <>{moment(value).utc().format('YYYY-MM-DD HH:mm:ss')}</>
                },
            },
        ]

        return (
            <React.Fragment>
                <ReportTable data={report} columns={columns} />
            </React.Fragment>
        )
    }

    return (
        <div>
            <div className="page-header d-flex align-items-center">
                <h1 className="mb-h1">Campaign Views</h1>
                <div className="ml-5">{affiliateId ? <AffiliateNavbar affiliateId={affiliateId} showSystemMessage={showSystemMessage} /> : <CampaignNavbar campaignId={campaignId} showSystemMessage={showSystemMessage} />}</div>
            </div>
            <div className="row">
                <div className="col-lg-6">
                    <div className="card">
                        <div className="card-body p-0">
                            <div className="d-flex justify-content-between p-3">
                                <div className="d-flex">
                                    <div className="mr-4 d-flex align-items-center">
                                        <h1 className="mb-h1-dark mr-2">{dataLoaded ? affiliateId ? <Affiliate aid={affiliateId} name={affiliate.name} priority={affiliate.priority.name} status={affiliate.status.name} /> : <Campaign oid={campaignId} name={campaign.name} status={campaign.status.value} /> : spinner}</h1>
                                    </div>
                                    <DateRangeFilter quickDate={quickDate} selectedStartDate={selectedStartDate} selectedEndDate={selectedEndDate} handleChangeStart={handleChangeStart} handleChangeEnd={handleChangeEnd} handleQuickDate={handleQuickDate} />
                                    <button onClick={refreshReport} className="btn btn-sm btn-primary">
                                        Refresh Report
                                    </button>
                                </div>
                            </div>
                            {dataLoaded ? report.length === 0 ? <div className="p-3">No stats for the current parameters.</div> : getReportOutput() : <Loading />}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CampaignViews
